import axios from "../../axios-auth";
import qs from "qs";
import { i18n, PREFIX } from "../../i18n.js";
import { pathOr } from "ramda";
import hash from "object-hash";

const state = {
  changeOptionsData: {},
  isChangeOptionsLoading: false,
  isPageOptionsLoading: false,
  beforeChangeOptionsCallback: null,
  afterChangeOptionsCallback: null,
  afterChangePageOptionCallback: null,
  onCartSubmitCallback: _ => _,
  addToCartCallbacks: [],
  initFinalizeCallback: null,
  photoMappingCallback: null,
  matrixOneSelection: false,
  callChangeOptions: true,
  quantityCode: null,
  prevChangeOptionsData: null
};

const getters = {
  getPrevChangeOptionsData: state => {
    return state.prevChangeOptionsData;
  },
  getPersonalizationCustomPrices: state => {
    var prices = {};
    for (var qty in state.changeOptionsData.price_table) {
      if (qty.includes("custom_qty_")) {
        if (
          state.changeOptionsData.price_table[qty].hasOwnProperty(
            "formatted_base_price"
          )
        ) {
          prices[state.changeOptionsData.price_table[qty].quantity] =
            state.changeOptionsData.price_table[qty].formatted_base_price;
        } else {
          prices[state.changeOptionsData.price_table[qty].quantity] = i18n.n(
            state.changeOptionsData.price_table[qty].base_price,
            "currency"
          );
        }
      }
    }

    return prices;
  },
  getQuantityCode: state => {
    return state.quantityCode;
  },
  getChangeOptionsTemplate: state => {
    var template = pathOr(0, ["changeOptionsData", "template"], state);
    if (template && template.length == 0) {
      return 0;
    }
    return template;
  },
  getCallChangeOptions: state => {
    return state.callChangeOptions;
  },
  getMatrixOneSelection: (state, getters) => {
    if (getters.getIsUploadWithoutConfiguration) {
      return true;
    }
    return state.matrixOneSelection;
  },
  getPackingTdTexturesFromTemplateMapping: state => {
    return state.changeOptionsData.td_data
      ? state.changeOptionsData.td_data
      : null;
  },

  getSelectedOption: (state, getters) => data => {
    if (getters.getIsMyAccount) {
      return getters.getMyAccountSelection["PP_" + data.pp][data.option];
    } else if (!state.callChangeOptions) {
      return "";
    }
    return state.changeOptionsData.pp_opt["PP_" + data.pp][data.option];
  },
  getQuantity: (state, getters) => {
    if (getters.getPersonalizationQuantityWithPrice) {
      return getters.getQuantityField;
    }
    if (state.changeOptionsData.qty != undefined) {
      return state.changeOptionsData.qty;
    }
    return getters.getQuantityField;
  },
  getSummary: state => {
    var summary = [];
    for (let pp in state.changeOptionsData.product_selection.productparts) {
      var ppObj = state.changeOptionsData.product_selection.productparts[pp];
      var data = {};
      for (let pageOptionKey in ppObj.prodpart_options) {
        var item = ppObj.prodpart_options[pageOptionKey];

        data[i18n.t(PREFIX.PO + item.po_name)] = i18n.t(
          PREFIX.POV + item.po_value
        );
      }
      var summaryItem = {
        name: i18n.t(PREFIX.PP + ppObj.prodpart_name),
        data
      };

      summary.push(summaryItem);
    }
    return summary;
  },
  getPhotoMapping: state => {
    return state.changeOptionsData.photo ? state.changeOptionsData.photo : null;
  },
  getFactsheet: state => {
    return state.changeOptionsData.factsheet_files
      ? state.changeOptionsData.factsheet_files
      : null;
  },
  getIsChangeOptionsEmpty: state => {
    var no_qty = Object.keys(state.changeOptionsData).filter(el => {
      return el != "qty";
    });
    return no_qty.length == 0;
  },
  getIsPageOptionsLoading: (state, getters) => {
    return getters.getEnableLoader ? state.isPageOptionsLoading : false;
  },
  getBeforeChangeOptionsCallback: state => {
    return state.beforeChangeOptionsCallback;
  },
  getAfterChangeOptionsCallback: state => {
    return state.afterChangeOptionsCallback;
  },
  getAfterChangePageOptionCallback: state => {
    return state.afterChangePageOptionCallback;
  },
  getInitFinalizeCallback: state => {
    return state.initFinalizeCallback;
  },
  getPhotoMappingCallback: state => {
    return state.photoMappingCallback;
  },
  getAddToCartCallbacks: state => {
    return state.addToCartCallbacks;
  },
  getOnCartSubmitCallback: state => {
    return state.onCartSubmitCallback;
  },
  getChangeOptionsPostData: (
    state,
    getters,
    rootState,
    rootGetters
  ) => makeCall => {
    if (getters.getIsChangeOptionsEmpty) {
      return rootGetters.getInitialChangeOptionsPostData; //getters
    }

    var qties = rootGetters.getCustomQuantitiesLabels;

    let postData = {
      webproduct: rootGetters.getWebProductId,
      qty: state.changeOptionsData.qty,
      custom_quantities: qties.length == 0 ? "" : qties
    };
    if (getters.getStoreCode) {
      postData["store_code"] = getters.getStoreCode;
    }
    if (getters.getAppSelectionId) {
      postData["selection"] = getters.getSelectionId;
    }

    var data = state.changeOptionsData;

    for (let option in data.pp_opt) {
      if (option.startsWith("PP_")) {
        for (let attribute in data.pp_opt[option]) {
          postData[
            "print_options[" + option + "][" + attribute + "][]"
          ] = Array.isArray(data.pp_opt[option][attribute])
            ? data.pp_opt[option][attribute][0]
            : data.pp_opt[option][attribute];
        }
      } else if (option.startsWith("PP")) {
        postData["print_options[" + option + "][]"] =
          rootGetters.getActiveProductPartCode;
      } else {
        if (makeCall) {
          if (Array.isArray(data.pp_opt[option][option])) {
            if (data.pp_opt[option][option].length) {
              postData["print_options[" + option + "][" + option + "]"] =
                data.pp_opt[option][option];
            } else {
              postData["print_options[" + option + "][" + option + "][]"] = "";
            }
          } else {
            postData["print_options[" + option + "][" + option + "][]"] =
              data.pp_opt[option][option];
          }
        } else {
          if (Array.isArray(data.pp_opt[option][option])) {
            if (data.pp_opt[option][option].length) {
              for (var item in data.pp_opt[option][option]) {
                postData[
                  "print_options[" + option + "][" + option + "][" + item + "]"
                ] = data.pp_opt[option][option][item];
              }
            } else {
              postData["print_options[" + option + "][" + option + "][]"] = "";
            }
          } else {
            postData["print_options[" + option + "][" + option + "][]"] =
              data.pp_opt[option][option];
          }
        }
      }
    }

    var preflightInfo = getters.getPreflightSendData;
    postData = { ...postData, ...preflightInfo };

    return postData;
  },
  getChangeOptionsHiddenInputs: (state, getters, rootState, rootGetters) => {
    var data = getters.getChangeOptionsPostData(false);
    delete data.qty; // not needed

    // add new field for packing
    if (getters.getIsPackingEnabled) {
      var packingData = getters.getPackingHiddenInputs;
      data = { ...data, ...packingData };
    }

    if (getters.getShowCostCenter) {
      data["costcenter_number"] = getters.getCostCenter;
    }

    /*if (getters.getStoreCode) {
      data["store_code"] = getters.getStoreCode;
    }*/

    return data;
  },
  getChangeOptionsData: state => {
    return state.changeOptionsData;
  },
  getChangeOptionsDataPPOpt: state => {
    return state.changeOptionsData.pp_opt;
  },
  getQuantities: state => {
    var items = [];
    for (var qty in state.changeOptionsData.price_table) {
      var item = {
        code: qty,
        // code: state.changeOptionsData.price_table[qty].quantity,
        ...state.changeOptionsData.price_table[qty]
      };

      if (
        state.changeOptionsData.qty ==
        state.changeOptionsData.price_table[qty].quantity
      ) {
        item["active"] = true;
      }

      items.push(item);
    }

    items.sort(function (a, b) {
      var inta = parseInt(a.quantity);
      var intb = parseInt(b.quantity);
      return inta == intb ? 0 : inta > intb ? 1 : -1;
    });

    return items;
  },
  getHasGrossPrice: state => {
    for (const qty of Object.keys(state.changeOptionsData.price_table)) {
      if (state.changeOptionsData.price_table[qty].gross_price) {
        return true;
      }
      break;
    }
    return false;
  },
  getQuantitiesValues: state => {
    var items = [];
    for (var qty in state.changeOptionsData.price_table) {
      items.push(state.changeOptionsData.price_table[qty].quantity);
    }
    return items;
  },
  getDenyRules: state => {
    return state.changeOptionsData.deny_rules;
  },
  getInformation: state => {
    return state.changeOptionsData.information;
  },
  getShowChangeOptionsLoader: (state, getters) => {
    return getters.getEnableLoader ? state.isChangeOptionsLoading : false;
  },
  getIsChangeOptionsLoading: (state, getters) => {
    return state.isChangeOptionsLoading;
  }
};

const mutations = {
  setMatrixOneSelection: (state, payload) => {
    state.matrixOneSelection = payload;
  },
  setIsChangeOptionsLoading: (state, payload) => {
    state.isChangeOptionsLoading = payload;
  },

  setPageOption: (
    state,
    { getters, rootState, rootGetters, payload, dispatch }
  ) => {
    var activePageOption = getters.getActivePageOptions;
    if (payload.option) {
      activePageOption = payload.option;
    }

    if (getters.getAfterChangePageOptionCallback) {
      dispatch("callAfterChangePageOptionCallback", {
        value: payload.value,
        option: activePageOption,
        type: "main"
      });
    }
    // array values set ???
    var changeOptionsDataPPOpt = { ...getters.getChangeOptionsDataPPOpt };
    changeOptionsDataPPOpt["PP_" + rootState.webproduct.activeProductPartCode][
      activePageOption
    ] = [payload.value];
    state.changeOptionsData.pp_opt = changeOptionsDataPPOpt;

    if (payload.layout) {
      // move to the next item
      var activePageOptions = { ...rootState.webproduct.activePageOptions };
      var activeProductPageOptionsKyes = Object.keys(
        getters.getActiveProductPageOptions
      );
      var index = activeProductPageOptionsKyes.indexOf(activePageOption);
      if (index > -1) {
        if (index != activeProductPageOptionsKyes.length - 1) {
          activePageOptions[rootState.webproduct.activeProductPartCode] =
            activeProductPageOptionsKyes[++index];
          rootState.webproduct.activePageOptions = activePageOptions;
        } else {
          // move to the next PP if it exists
          var productPartsCodesKeys = rootGetters.getProductPartsCodes;
          var indexPP = productPartsCodesKeys.indexOf(
            rootState.webproduct.activeProductPartCode
          );
          if (indexPP != -1) {
            if (indexPP != productPartsCodesKeys.length - 1) {
              rootState.webproduct.activeProductPartCode =
                productPartsCodesKeys[++indexPP];
              activePageOptions[
                rootState.webproduct.activeProductPartCode
              ] = Object.keys(getters.getActiveProductPageOptions)[0];
              rootState.webproduct.activePageOptions = activePageOptions;
            } else {
              // finalized selection for all PP
              dispatch("setMatrixComplete", true);
              //rootState.config.showUpload = true;
            }
          }
        }
      }
    }
  },
  setOtherOption: (state, { getters, payload, dispatch }) => {
    var changeOptionsDataPPOpt = { ...getters.getChangeOptionsDataPPOpt };
    changeOptionsDataPPOpt[payload.option][payload.option] = Array.isArray(
      payload.value
    )
      ? payload.value
      : [payload.value];
    state.changeOptionsData.pp_opt = changeOptionsDataPPOpt;

    if (getters.getAfterChangePageOptionCallback) {
      dispatch("callAfterChangePageOptionCallback", {
        value: payload.value,
        option: payload.option,
        type: "other"
      });
    }
  },
  setChangeOptionsData: (state, payload) => {
    state.changeOptionsData = payload;
  },
  setQuantity: (state, payload) => {
    state.changeOptionsData = { ...state.changeOptionsData, qty: payload.qty };
    state.quantityCode = payload.qtyCode;
  },
  setBeforeChangeOptionsCallback: (state, payload) => {
    state.beforeChangeOptionsCallback = payload;
  },
  setAfterChangeOptionsCallback: (state, payload) => {
    state.afterChangeOptionsCallback = payload;
  },
  setAfterChangePageOptionCallback: (state, payload) => {
    state.afterChangePageOptionCallback = payload;
  },
  setInitFinalizeCallback: (state, payload) => {
    state.initFinalizeCallback = payload;
  },
  registerAddToCartCallback: (state, payload) => {
    if (typeof payload === "function")
      state.addToCartCallbacks = [...state.addToCartCallbacks, payload];
  },
  registerOnCartSubmitCallback: (state, payload) => {
    if (typeof payload === "function") state.onCartSubmitCallback = payload;
  },
  setPhotoMappingCallback: (state, payload) => {
    state.photoMappingCallback = payload;
  },
  setIsPageOptionsLoading: (state, payload) => {
    state.isPageOptionsLoading = payload;
  },
  setCallChangeOptions: (state, payload) => {
    state.callChangeOptions = payload;
  },
  setPrevChangeOptionsData: (state, payload) => {
    state.prevChangeOptionsData = payload;
  }
};

const actions = {
  setPageOptionFormat: (
    { commit, getters, rootState, rootGetters, dispatch },
    payload
  ) => {
    commit("setPageOption", {
      getters,
      rootState,
      rootGetters,
      payload,
      dispatch
    });
  },
  setPageOption: (
    { commit, getters, rootState, rootGetters, dispatch },
    payload
  ) => {
    commit("setIsPageOptionsLoading", true);
    commit("setMatrixOneSelection", true);

    if (payload.optionType == "main") {
      if (payload.option == rootGetters.getProductPartsOptionCode) {
        commit("setActiveProductPartName", payload.value);
        commit("setIsPageOptionsLoading", false);
        return;
      } else {
        commit("setPageOption", {
          getters,
          rootState,
          rootGetters,
          payload,
          dispatch
        });
        if (getters.getIsPackingEnabled) {
          dispatch("setPackingOption", payload);
          if (getters.getRefreshGetDataPP.includes(payload.option)) {
            dispatch("packingGetData", { callChangeOptions: false });
          }
        }
      }
    } else {
      // other option
      commit("setOtherOption", {
        getters,
        rootState,
        rootGetters,
        payload,
        dispatch
      });
    }
    if (payload.optionType !== "quantity") {
      dispatch("changeOptions", payload);
    }
    // will be set in changeOptions
    //commit("setIsPageOptionsLoading", false);
  },
  changeOptions: ({ commit, getters, rootState, dispatch }, payload) => {
    if (!getters.getCallChangeOptions || !getters.getCallChangeOptionPerType) {
      if (payload.initialLoading) {
        dispatch("setIsLoading", false);
        dispatch("callInitialLoadingFinalized", {
          type: "changeOptions",
          status: 1
        });
      }
      return;
    }
    commit("setIsChangeOptionsLoading", true);
    var changeOptionsPostData = getters.getChangeOptionsPostData(true);
    if (getters.getQuantityCode) {
      if (getters.getIsChangeOptionsEmpty)
        changeOptionsPostData["print_options[quantity][quantity][]"] =
          getters.getQuantityCode;
      else
        changeOptionsPostData["print_options[quantity][quantity]"] = [
          getters.getQuantityCode
        ];
    }

    //cache changeOptions call
    if (hash(changeOptionsPostData) == getters.getPrevChangeOptionsData) {
      // same hash ... no need to call again changeOptions
      commit("setIsChangeOptionsLoading", false);
      commit("setIsPageOptionsLoading", false);
      return;
    }

    commit("setPrevChangeOptionsData", hash(changeOptionsPostData));

    if (getters.getBeforeChangeOptionsCallback) {
      var changeOptionsPostDataResponse = getters.getBeforeChangeOptionsCallback(
        changeOptionsPostData
      );
      if (changeOptionsPostDataResponse) {
        changeOptionsPostData = changeOptionsPostDataResponse;
      }
    }
    axios.instance
      .post(
        getters.getUrl(axios.apiChangeOption),
        qs.stringify(changeOptionsPostData)
      )
      .then(response => {
        if (getters.getAfterChangeOptionsCallback) {
          getters.getAfterChangeOptionsCallback(response.data);
        }

        if (!response.data.success) {
          console.log("Change options error : " + response.data.message);
          throw new Error("Could not get prices for selection");
        }
        var responseData = response.data;
        if (
          response.data.hasOwnProperty("success") &&
          response.data.hasOwnProperty("data")
        ) {
          responseData = response.data.data;
        }

        commit("setChangeOptionsData", responseData);
        if (payload.initialLoading) {
          if (getters.getIsPackingEnabled) {
            dispatch("setPreview3DLoading", true);
            dispatch("loadInitialPackingOptions", payload);
            dispatch("packingGetData", {
              callChangeOptions: true,
              setLoading: true
            });
          } else {
            dispatch("setIsLoading", false);
          }
          dispatch("callInitialLoadingFinalized", {
            type: "changeOptions",
            status: 1
          });
        }
        if (getters.getIsLfp) {
          dispatch("parseChangeOptionResponse", responseData);
        }
        if (responseData.preflight_check_updated) {
          dispatch(
            "setPreflightCheckData",
            responseData.preflight_check_updated
          );
        }

        if (getters.getPhotoMappingCallback && getters.getPhotoMapping) {
          getters.getPhotoMappingCallback(getters.getPhotoMapping);
        }

        if (responseData.template) {
          dispatch("setChangeOptionsTemplate", responseData.template);
        }

        if (
          getters.getIsPackingEnabled &&
          JSON.stringify(getters.getCurrentTdData) !=
            JSON.stringify(getters.getTdTexture)
        ) {
          dispatch("setTdImage");
        }

        commit("setIsChangeOptionsLoading", false);
        commit("setIsPageOptionsLoading", false);
      })
      .catch(error => {
        console.log(error);
        if (payload.initialLoading) {
          dispatch("setNetworkError", error);
          dispatch("callInitialLoadingFinalized", {
            type: "changeOptions",
            status: 0
          });
          //commit("setIsLoading", false);
        }
        commit("setIsChangeOptionsLoading", false);
        commit("setIsPageOptionsLoading", false);
      });
  },
  setQuantity: ({ commit, getters, dispatch }, payload) => {
    commit("setQuantity", payload);
    dispatch("changeOptions", {});
  },
  setBeforeChangeOptionsCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setBeforeChangeOptionsCallback", payload);
  },
  setAfterChangeOptionsCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setAfterChangeOptionsCallback", payload);
  },
  setAfterChangePageOptionCallback: (
    { commit, getters, dispatch },
    payload
  ) => {
    commit("setAfterChangePageOptionCallback", payload);
  },
  callAfterChangePageOptionCallback: (
    { commit, getters, dispatch },
    payload
  ) => {
    if (payload.type == "main") {
      const allPPOptions = getters.getAllProductPageOptions(true);
      if (allPPOptions[payload.option]) {
        const items = allPPOptions[payload.option].values.filter(el => {
          return el.value == payload.value;
        });
        if (items.length > 0) {
          getters.getAfterChangePageOptionCallback({
            ...items[0],
            pp: getters.getActiveProductPartCode,
            option: payload.option,
            multiple: allPPOptions[payload.option].type
          });
        } else {
          if (
            payload.option == "format" &&
            payload.value.startsWith("custom_")
          ) {
            const itemsFormat = getters.getCustomFormats.filter(el => {
              return el.value == payload.value;
            });
            if (itemsFormat.length > 0) {
              getters.getAfterChangePageOptionCallback({
                attributes: {
                  width: "" + itemsFormat[0].width,
                  height: "" + itemsFormat[0].height
                },
                label: itemsFormat[0].label,
                value: payload.value,
                pp: getters.getActiveProductPartCode,
                option: payload.option,
                multiple: allPPOptions[payload.option].type
              });
            }
          }
        }
      }
    } else if (payload.type == "other") {
      const options = getters.getWebProductData.options;
      if (options[payload.option]) {
        let items = options[payload.option].values.filter(el => {
          if (options[payload.option].type == "multiple") {
            return payload.value.includes(el.value);
          } else {
            return el.value == payload.value;
          }
        });
        if (options[payload.option].type == "multiple") {
          var newItems = {};
          for (var idx in items) {
            newItems[items[idx].value] = { ...items[idx] };
          }
          items = [{ attributes: newItems }];
        }

        if (items.length > 0) {
          getters.getAfterChangePageOptionCallback({
            ...items[0],
            pp: null,
            option: payload.option,
            value: payload.value,
            multiple: options[payload.option].type
          });
        }
      }
    }
  },
  setInitFinalizeCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setInitFinalizeCallback", payload);
  },
  registerAddToCartCallback: ({ commit, getters, dispatch }, payload) => {
    commit("registerAddToCartCallback", payload);
  },
  registerOnCartSubmitCallback: ({ commit, getters, dispatch }, payload) => {
    commit("registerOnCartSubmitCallback", payload);
  },
  setPhotoMappingCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setPhotoMappingCallback", payload);
  },
  setCallChangeOptions: ({ commit }, payload) => {
    commit("setCallChangeOptions", payload);
  },
  callInitialLoadingFinalized: ({ commit, getters }, payload) => {
    if (getters.getInitFinalizeCallback) {
      getters.getInitFinalizeCallback(payload);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
